module.exports = __webpack_public_path__ + "img/1.a876969e.webp";